import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import apiClient from "../../../../../helpers/api-client";

export type User = {
	id: number;
	uuid: string;
	name?: string;
	profilePictureUrl?: string;
};

const usersApi = createApi({
	reducerPath: "users",
	baseQuery: async (arg, api, extraOptions) =>
		fetchBaseQuery({
			fetchFn: apiClient.fetch.bind(apiClient),
			baseUrl: `/`,
		})(arg, api, extraOptions),
	tagTypes: ["User", "CurrentUserId"],
	endpoints: (builder) => ({
		getUser: builder.query<User, string>({
			query: (uuid) => `api/verity/institute-user/uuid:${uuid}`,
			transformResponse: (user: {
				id: number;
				uuid: string;
				userInfo?: { full_name?: string; profile_picture?: string };
			}) => ({
				...user,
				name: user.userInfo?.full_name,
				profilePictureUrl: user.userInfo?.profile_picture,
			}),
			providesTags: (result) => (result ? [{ type: "User" as const, id: result.uuid }] : ["User"]),
		}),
		getCurrentUserId: builder.query<string, void>({
			query: () => "api/access-control/user/self",
			transformResponse: ({ id }: { id: string }) => id,
			providesTags: ["CurrentUserId"],
		}),
	}),
});

export default usersApi;
